import { render, staticRenderFns } from "./TeacherAdmin.vue?vue&type=template&id=43f1d6f2&scoped=true&"
import script from "./TeacherAdmin.vue?vue&type=script&lang=js&"
export * from "./TeacherAdmin.vue?vue&type=script&lang=js&"
import style0 from "./TeacherAdmin.vue?vue&type=style&index=0&id=43f1d6f2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f1d6f2",
  null
  
)

export default component.exports